/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListObjectivesQueryResponse, ListObjectivesPathParams, ListObjectivesQueryParams, ListObjectives400, ListObjectives401, ListObjectives403, ListObjectives404, ListObjectives409, ListObjectives500 } from "../../types/planningTasksController/ListObjectives.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListObjectivesUrl(organizationId: ListObjectivesPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/objectives` as const }
  return res
}

/**
 * @summary List objectives across the organization (optionally one farm via ?establishmentId)
 * {@link /api/organizations/:organizationId/objectives}
 */
export async function listObjectives(organizationId: ListObjectivesPathParams["organizationId"], params?: ListObjectivesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListObjectivesQueryResponse, ResponseErrorConfig<ListObjectives400 | ListObjectives401 | ListObjectives403 | ListObjectives404 | ListObjectives409 | ListObjectives500>, unknown>({ method : "GET", url : getListObjectivesUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}